import {
  deleteAdminV1OrgSkuRulesId,
  getAdminV1OrgSkuRules,
  getAdminV1OrgSkuRulesId,
  getAdminV1OrgSkuRulesIdRuns,
  getAdminV1OrgSkuRulesIdRunsRunId,
  getAdminV1OrgSkuRulesResolve,
  patchAdminV1OrgSkuRulesId,
  postAdminV1OrgAttributesIdValuesSuggestSkuCodes,
  postAdminV1OrgSkuRules,
  postAdminV1OrgSkuRulesIdApply,
  postAdminV1OrgSkuRulesPreview,
  type CreateSkuRuleRequest,
  type SkuRule,
  type SkuRuleApplyRequest,
  type SkuRulePreview,
  type SkuRulePreviewRequest,
  type SkuRuleResolve,
  type SkuRuleRun,
  type SuggestSkuCodesResponse,
  type UpdateSkuRuleRequest,
} from '@nucleus-commerce/api-client/admin';

/** SKU rules (D-161): a bounded `{ items }` list, previews of unsaved templates, apply runs. */
export const skuRulesApi = {
  list: (): Promise<SkuRule[]> => getAdminV1OrgSkuRules().then((r) => r.items),
  get: (id: string): Promise<SkuRule> => getAdminV1OrgSkuRulesId({ id }),
  create: (body: CreateSkuRuleRequest): Promise<SkuRule> => postAdminV1OrgSkuRules(body),
  update: (id: string, body: UpdateSkuRuleRequest): Promise<SkuRule> =>
    patchAdminV1OrgSkuRulesId({ id }, body),
  remove: (id: string): Promise<void> => deleteAdminV1OrgSkuRulesId({ id }),
  /** A POST that reads: renders samples without consuming the counter. */
  preview: (body: SkuRulePreviewRequest): Promise<SkuRulePreview> =>
    postAdminV1OrgSkuRulesPreview(body),
  /** No type: the default rule, as for a product without a type. */
  resolve: (productTypeId: string | null): Promise<SkuRuleResolve> =>
    getAdminV1OrgSkuRulesResolve(productTypeId ? { productTypeId } : undefined),
  apply: (id: string, body: SkuRuleApplyRequest): Promise<SkuRuleRun> =>
    postAdminV1OrgSkuRulesIdApply({ id }, body),
  listRuns: (id: string): Promise<SkuRuleRun[]> =>
    getAdminV1OrgSkuRulesIdRuns({ id }).then((r) => r.items),
  getRun: (id: string, runId: string): Promise<SkuRuleRun> =>
    getAdminV1OrgSkuRulesIdRunsRunId({ id, runId }),
  /** Fills missing SKU codes on an attribute's values; answers what it set. */
  suggestSkuCodes: (attributeId: string): Promise<SuggestSkuCodesResponse> =>
    postAdminV1OrgAttributesIdValuesSuggestSkuCodes({ id: attributeId }),
};
